import axios from "axios";
import { useAuthStore } from "../stores/auth";


const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL, // global API URL
  // withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const auth = useAuthStore();
  if (auth.token) {
    config.headers.Authorization = `Bearer ${auth.token}`;
  }
  // GET requests to the same URL are made under different accounts (e.g. the
  // "login as staff" flow, where several sessions hit /fecthPerms with an
  // identical URL). The browser HTTP cache keys on URL, not on the
  // Authorization header, so without this it can silently serve a previous
  // user's cached response. Force revalidation on every request.
  config.headers["Cache-Control"] = "no-cache";
  config.headers["Pragma"] = "no-cache";
  return config;
});


// A page often fires several requests at once; when the token expires they all
// come back 401. Redirect only once instead of once per request.
let redirectingToLogin = false;

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !redirectingToLogin) {
      const auth = useAuthStore();
      auth.clearAuth();
      if (window.location.pathname !== "/login") {
        redirectingToLogin = true;
        window.location.replace("/login");
      }
    }
    return Promise.reject(error);
  }
);
export default api;
